/**
 * External dependencies
 */
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Box, Stack } from '@towersystems/towersystems-design-system';
import { map } from 'lodash';

/**
 * Internal dependencies
 */
import Card from 'components/card';
import { requestOperations } from 'state/operations/actions';
import usePagination from 'modules/dashboard/pagination/use-pagination';
import OperationsListTable from './operations-list-table';
import OperationDetailsModal from 'blocks/operation-details-modal';

/**
 * Style dependencies
 */
import './styles.scss';

const OperationsList = ({ connectionId, reload, ...props }) => {
    const { currentItems, footer, requestItems, isRequesting } = usePagination(props.requestOperations, {
        criteria: { connection: connectionId },
        orderBy: { createdAt: 'desc' },
    });

    // hack; need to be able to reload the data from parent
    useEffect(() => {
        if (reload == true) {
            requestItems();
        }
    }, [reload]);

    return (
        <React.Fragment>
            <Stack className='resources__list-wrapper' space='large'>
                <Card>
                    <OperationsListTable requestItems={requestItems} requesting={isRequesting} operations={currentItems} />
                </Card>
                {footer}
            </Stack>
            <OperationDetailsModal onClosed={requestItems} />
        </React.Fragment>
    );
};

export default connect((state) => ({}), {
    requestOperations,
})(OperationsList);
